import React, { Component } from "react";
import PropTypes from "prop-types";
import { batch, connect } from "react-redux";
import axios from "axios";
import {
  StyledSlideSubtitle,
  StyledSlideTitle,
} from "../../styled/details/stylesDetails";
import { wsMagicResize } from "../../../_actions/webSocketAction";
import {
  fetchCategories,
  fetchFormats,
  resetSlidePresets,
  searchFormats,
} from "../../../_actions/slidePresetActions";

import {
  RequestTemplateContent,
  ShowCenterSpinner,
} from "../../common/statelessView";
import dashboardArtBoardPlaceholder from "../../../assets/images/dashboardArtBoardPlaceholder.png";

import TLDRInfiniteGalleryGridLayout from "../../common/TLDRInfiniteGalleryGridLayout";
import { debounce } from "lodash";
import CustomSizeProjectModal from "../../common/CustomSizeProjectModal";
import { FaPlus, FaSearch, FaTimesCircle } from "react-icons/fa";
import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Button,
  Flex,
  Box,
} from "@chakra-ui/react";
import { withTranslation } from "react-i18next";

export class SlidePresets extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      showCustomStorySizeModal: false,
    };
  }

  loadPage = (groupKey) => {
    this.props.fetchFormats("", { ...this.props, groupKey });
  };

  componentDidMount() {
    batch(() => {
      this.props.resetSlidePresets();
      this.props.fetchFormats("", { ...this.props, page: 1 });
    });
  }

  fetchCategories() {
    this.props
      .fetchCategories(this.props, this.signal.token)
      .then((result) => {})
      .catch((error) => console.error("Failed to fetch catgoires"));
  }

  onChange = (customWidth, customHeight) => {
    const design = {
      image_height: customHeight,
      image_width: customWidth,
    };
    this.applyDesign(design);
    this.setState((state) => ({
      showCustomStorySizeModal: !state.showCustomStorySizeModal,
    }));
  };

  debouncedSearch = debounce(async () => {
    this.startSearch();
  }, 500);

  onInputChange = (event) => {
    let searchText = event.target.value; // this is the search text
    this.setState({ searchText }, () => {
      this.debouncedSearch();
    });
  };

  clearSearch = (event) => {
    this.setState({ searchText: "" }, () => {
      this.startSearch();
    });
  };

  toggleCustomSizePopup = () => {
    this.setState((state) => ({
      selectedCategory: "custom",
      showCustomStorySizeModal: !state.showCustomStorySizeModal,
    }));
  };

  startSearch = () => {
    batch(() => {
      this.props.resetSlidePresets();
      this.props
        .searchFormats(this.state.searchText, this.props)
        .then(() => {});
    });
  };

  render() {
    const { t , selectedTab} = this.props;
    const { presets, hasMore, loaded } = this.props.slidePresets;
    const { searchText, showCustomStorySizeModal } = this.state;
    const formatContent = presets.map((preset, index) => {
      const { id, image_height, image_width, title, display_name, image } =
        preset;

      return (
        <React.Fragment key={index}>
          <div
            className="item item-preset"
            onClick={() => this.applyDesign(preset)}
          >
            <Box mb={1}>
              <img
                width="100%"
                src={!image ? dashboardArtBoardPlaceholder : image}
                alt={title}
              />
            </Box>
            <div className="preset-item-footer">
              <StyledSlideTitle>{display_name}</StyledSlideTitle>
              <StyledSlideSubtitle>
                {image_width} x {image_height} px
              </StyledSlideSubtitle>
            </div>
          </div>
        </React.Fragment>
      );
    });

    return (
      <>
        <Flex m="0" maxWidth="700px" justifyContent="center">
          <InputGroup color="white">
            <InputLeftElement children={<FaSearch />} />
            <Input
              placeholder={t("search.search_formats")}
              aria-label="Search"
              onChange={this.onInputChange}
              value={searchText}
              autoFocus={true}
            />
            {searchText !== "" && (
              <InputRightElement
                children={<FaTimesCircle onClick={this.clearSearch} />}
              />
            )}
          </InputGroup>
        </Flex>
        <hr className="tldr-hl" />

        <Button
          rightIcon={<FaPlus />}
          mb={2}
          isFullWidth
          onClick={() => this.toggleCustomSizePopup()}
        >
          {t("custom_size")}
        </Button>
        <Flex
          flexDirection="column"
          position="relative"
          flexWrap="nowrap"
          m="0"
          h="full"
          grow={1}
        >
          {loaded && presets.length > 0 ? (
            <TLDRInfiniteGalleryGridLayout
              selectedTab={selectedTab}
              className="preset-gallery"
              hasMore={hasMore}
              loadPage={this.loadPage}
              loaded={loaded} // Change its value whenever data get loaded.
            >
              {formatContent}
            </TLDRInfiniteGalleryGridLayout>
          ) : loaded && presets.length === 0 ? (
            <RequestTemplateContent text={t("no_formats")} />
          ) : (
            <ShowCenterSpinner loaded={loaded} />
          )}
        </Flex>
        {showCustomStorySizeModal && (
          <CustomSizeProjectModal
            okButton="Resize now"
            onHide={(e) => {
              this.setState({
                selectedCategory: "all",
                showCustomStorySizeModal: false,
              });
            }}
            onYes={this.onChange}
          ></CustomSizeProjectModal>
        )}
      </>
    );
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  applyDesign = (design) => {
    const { activePage } = this.props;
    let message = {
      page: activePage.id,
      image_width: design.image_width,
      image_height: design.image_height,
    };

    this.props.wsMagicResize(message);
  };
}

SlidePresets.defaultProps = {
  page: 1,
};

SlidePresets.propTypes = {
  page: PropTypes.number.isRequired,
  activePage: PropTypes.object.isRequired,
  slidePresets: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  activePage: state.editor.activePage,
  slidePresets: state.slidePresets,
  page: state.slidePresets.page,
});

const mapDispatchToProps = (dispatch) => ({
  wsMagicResize: (payload) => dispatch(wsMagicResize(payload)),
  fetchCategories: (props, signalToken) =>
    dispatch(fetchCategories(props, signalToken)),
  fetchFormats: (key, props) => dispatch(fetchFormats(key, props)),
  resetSlidePresets: () => dispatch(resetSlidePresets()),
  searchFormats: (searchTerm, props) =>
    dispatch(searchFormats(searchTerm, props)),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(SlidePresets)
);
